export enum PropertyTranslation {
    TITLE = "propertyTranslation.title",
    ATTRIBUTE = "propertyTranslation.attribute",
}